import React from 'react';
import { ContentBelowTopBar, TopBar } from "./ContentNavigation";
import { Card, Button } from 'react-bootstrap';
import { RouteComponentProps } from 'react-router-dom';
import ChronoCard from "./ChronoCard";

import ChronoImage from "../../images/iconChrono@3x.png";
import {ChronoTitle, LogoContainer, LogoIcon} from "../navMenu/HeaderNavMenu";

const NoAccess: React.FC<RouteComponentProps> = (props) => {
    
    return (
        <div>
            <TopBar title="Accès restreint" />
            <ContentBelowTopBar>
                <ChronoCard style={{padding: 0, width: '60%', margin: 'auto', marginTop: 60}}>
                    <Card.Header style={{display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: 25, paddingBottom: 25}}>
                        <LogoContainer style={{margin: 0}}>
                            <LogoIcon src={ChronoImage} />
                            <ChronoTitle style={{color: 'black'}}>Chrono</ChronoTitle>
                        </LogoContainer>
                    </Card.Header>
                    <Card.Body style={{padding: 30}}>
                        <Card.Title>Vous n'avez pas accès à cette page</Card.Title>
                        <Card.Text>
                            Veuillez contacter l'administrateur de votre site pour plus de détails.
                        </Card.Text>
                        <Button variant="primary" onClick={() => props.history.push(`/`)}>Retour vers Tableau de bord</Button>
                    </Card.Body>
                </ChronoCard>
            </ContentBelowTopBar>
        </div> 
    )
}

export default NoAccess;